import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'user', 'User', [["path",{"d":"M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"}],["path",{"d":"M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"}]]);